/* eslint-disable max-len */
import React, { SVGAttributes } from 'react';

export default ({ color = '#FFF', ...props }: SVGAttributes<SVGElement> & { color?: string }) => (
	<svg width="24px" viewBox="0 0 24 24" {...props}>
		<path
			fill={color}
			d="M4.75 8a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0zm6 8a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0zm-.5-9H20v2h-9.75V7zm6 8H20v2h-3.75v-2zM5 15h4.75v2H5v-2z"
		/>
	</svg>
);
